import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';

export const Slider = styled.div`
  position: relative;
  height: 100%;

  .slick-dots {
    bottom: 16px;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;

    ${breakpoints.lg} {
      bottom: 24px;
    }

    li {
      margin: 0 4px;
      width: 24px;
      height: 4px;
      display: inline-block;

      ${breakpoints.lg} {
        margin: 0 8px;
        width: 32px;
        height: 8px;
      }

      button {
        background: ${({ theme }) => theme.secondary.gray};
        width: 24px;
        height: 4px;
        padding: 0;
        opacity: 1;
        border-radius: 10px;
        transition: all 0.2s ease-in-out;
        appearance: none;
        border: none;
        text-indent: -9999px;

        ${breakpoints.lg} {
          width: 32px;
          height: 8px;
        }

        &:before {
          display: none;
        }
      }

      &.slick-active,
      &:hover {
        button {
          background: ${({ theme }) => theme.base.white};
        }
      }
    }
  }
`;

export const Slide = styled.div`
  position: relative;
  width: 100%;
`;

export const SlideArrow = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  transform: none;
  z-index: 1;
  cursor: pointer;
  width: 25px;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex !important; // Overriding Slicks default behavior
  opacity: 0.5;
  transition: all 0.2s ease-in-out;

  ${breakpoints.lg} {
    width: 75px;
  }

  &:before {
    display: none;
  }

  &:hover {
    opacity: 1;
  }

  &:focus,
  &:active {
    outline: 3px solid ${({ theme }) => theme.primary.main};
  }

  > svg {
    width: 8px;
    height: 12px;
    fill: ${({ theme }) => theme.base.white};

    ${breakpoints.lg} {
      width: 25px;
      height: 40px;
    }
  }

  &.slick-next {
    right: 0;
    padding-right: 8px;

    ${breakpoints.md} {
      padding-right: 39px;
    }
  }

  &.slick-prev {
    left: 0;
    padding-left: 8px;

    ${breakpoints.md} {
      padding-left: 39px;
    }
  }
`;
